<template>
  <div class="work-cover">

    <div class="wrap">
        <div class="bg-wrap ani-fade-in">
            <!-- <img class="bg-cover" src="https://firebasestorage.googleapis.com/v0/b/mesh-fdc0c.appspot.com/o/work%2Frevir%2Fphotos%2FGroup%2053.jpg?alt=media&token=90f2ee4e-74cf-4db1-8a62-341e54109105" alt=""> -->
            <slot name="cover"></slot>
        </div>
        <!-- <div class="text-block d-f w-100 jc-c">
            <h1 class="tt-uc">Revir</h1>
            <h1 class="ws-pre"> – </h1>
            <h1>Apparel Brand</h1>
        </div> -->
        
    </div>

  </div>
</template>

<script>

export default {
  name: 'WorkCover',
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";

</style>
